export type ChangeType = 'feature' | 'improvement' | 'fix';

export interface ChangelogEntry {
  version: string;
  date: string;
  changes: { type: ChangeType; text: string }[];
}

/**
 * Release notes for the console. Structured data (the legacy page rendered a raw
 * CHANGELOG.md via react-markdown; the new build has neither file nor lib, so the
 * same content lives here and renders with design-system components). Newest first.
 */
export const CHANGELOG: ChangelogEntry[] = [
  {
    version: '2.4.0',
    date: 'June 2026',
    changes: [
      { type: 'feature', text: 'Service catalog detail pages with per-service console previews.' },
      { type: 'feature', text: 'Contact information form under Account → Information.' },
      { type: 'feature', text: 'PayPal payment capture and return flow on invoices.' },
      { type: 'feature', text: 'Private Zones — infrastructure hosts, datastores and networks.' },
      { type: 'improvement', text: 'Compute instance dialogs aligned with the v2 design system.' },
    ],
  },
  {
    version: '2.3.0',
    date: 'May 2026',
    changes: [
      { type: 'feature', text: 'Cloud Compute console — instances, networking, snapshots, backups.' },
      { type: 'feature', text: 'Managed Kubernetes — clusters, node pools, workloads and ingress.' },
      { type: 'improvement', text: 'CDN analytics and per-domain usage reporting.' },
      { type: 'fix', text: 'Dark-mode token consistency across the services pages.' },
    ],
  },
  {
    version: '2.2.0',
    date: 'April 2026',
    changes: [
      { type: 'feature', text: 'FastChannel playout management.' },
      { type: 'feature', text: 'Support tickets module with a rich detail view.' },
      { type: 'improvement', text: 'Redesigned account, billing and API-keys areas.' },
    ],
  },
];
